export default {
  soukecityId: '',
  cityName: '',
  topNav: [],
  currCityId: '',
  currCityName: ''
}



// WEBPACK FOOTER //
// ./src/store/state.js